import Logo from './Logo';

export default function LoadingScreen() {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center z-50 pointer-events-none overflow-hidden">
      {/* No background - let A-Frame grid show through */}

      {/* Logo - centered */}
      <div className="mb-6 relative z-10">
        <Logo size={260} />
      </div>

      {/* Loading indicator */}
      <div className="flex items-center gap-2 mb-6 relative z-10">
        <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse" />
        <span className="text-white/80 text-sm">Loading 360 experience...</span>
      </div>

      {/* Controls tutorial */}
      <div className="text-white/60 text-sm space-y-1 text-center bg-black/30 px-6 py-3 rounded-lg backdrop-blur-sm relative z-10">
        <p>Drag to look around</p>
        <p>Pinch to zoom • Use slider for horizon</p>
      </div>
    </div>
  );
}
